import SCheckbox from './Checkbox.styles';
import { TCheckboxProps } from './Checbox.types';

const Checkbox = (props: TCheckboxProps) => {
  return <SCheckbox {...props} />;
};

export default Checkbox;
